/* eslint-disable max-len */
/**
 * @file 任务运行相关ts文件
 * @author sunyingying01
 */

/**
 * 任务配置步骤枚举
 * 用于替代散落在代码中的 magic numbers
 */
export enum TaskStep {
    /** 步骤0: 文件上传（初始化算法和评估器文件上传） */
    FILE_UPLOAD = 0,
    /** 步骤1: 任务参数配置 */
    PARAMETER_CONFIG = 1,
    /** 步骤2: 任务冷启动 */
    COLD_START = 2,
    /** 步骤3: 续跑（演化重启） */
    CONTINUE_EVOLVE = 3,
    /** 步骤4: 续跑（兼容老任务） */
    CONTINUE_EVOLVE_LEGACY = 4
}

export const TASK_STRATEGIES_TXT = {
    'CREATED': '任务创建成功',
    'RUNNING': '任务正在执行',
    'FAILED': '任务失败',
    'CANCELLED': '任务被干预终止',
    'COMPLETED': '任务完成',
    'PAUSED': '已暂停'
};

/**
 * 任务筛选状态
 * status: 展示状态
 * value: 实际任务状态
 */
export const STATUS_OPTIONS: FiltetStatusOptionsType[] = [
    {label: '全部', status: 'ALL', value: ['ALL']},
    {label: '未开始', status: 'DRAFT', value: ['DRAFT', 'COPYFAILED', 'COPYING']},
    {label: '进行中', status: 'RUNNING', value: ['RUNNING', 'CREATED', 'INITIALING']},
    {label: '完成', status: 'COMPLETED', value: ['COMPLETED']},
    {label: '暂停', status: 'PAUSED', value: ['PAUSED']},
    {label: '终止', status: 'CANCELLED', value: ['CANCELLED', 'FAILED']}
];

export const STATUS_OPTIONS_MAP = {
    ALL: STATUS_OPTIONS[0].value,
    DRAFT: STATUS_OPTIONS[1].value,
    RUNNING: STATUS_OPTIONS[2].value,
    COMPLETED: STATUS_OPTIONS[3].value,
    PAUSED: STATUS_OPTIONS[4].value,
    CANCELLED: STATUS_OPTIONS[5].value
};

export const EvolveStageData = {
    initial_solution_set: [],
    sandbox_path_prefix: '',
    total_iteration: 0,
    max_generation: 0,
    duration: 0
};

export const ResultStageData = {
    /** 初始解集, fileInfo 数组 */
    initial_solution_set: [],
    /** 文件路径前缀 */
    sandbox_path_prefix: '',
    /** 总迭代次数, number类型 */
    total_iteration: 0,
    /** 最高得分 */
    max_combined_score: 0,
    /** 最优代际 */
    best_generation: 0,
    /** 执行时长 */
    duration: 0,
    /** 初始解集数量 */
    initial_solution_number: 0,
    /** 初始解集多样性 */
    current_diversity: 0
};

export const StageData = {
    /** 初始解集, fileInfo 数组 */
    initial_solution_set: [],
    /** 初始解集路径前缀 */
    sandbox_path_prefix: '',
    /** 当前解集, number类型 */
    current_solution: 0,
    /** 目标解集, number类型 */
    target_solution: 0,
    /** 当前多样性, number类型 */
    current_diversity: 0,
    /** 目标多样性, number类型 */
    target_diversity: 0,
    /** 初始解集数量 */
    initial_solution_number: 0,
    /** 任务执行时长 */
    duration: 0
};

export const ColdStartProgressData = {
    'progress': 0,
    'stage': 'COLDSTART',
    'stage_data': null,
    'status': ''
};

export const EvolveProgressData = {
    'progress': 0,
    'stage': 'EVOLVE',
    'stage_data': null,
    'report_url': '',
    'status': ''
};

export const DefaultFilter = {
    'is_initial_solution': false,
    'island_id': [],
    'source': []
};
